import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import { withStyles } from 'material-ui/styles';
import Input, { InputLabel } from 'material-ui/Input';
import { FormControl, FormHelperText } from 'material-ui/Form';
import { formatDate } from '../../../../../utils/date-utils';
import DatePickerInput from '../DatePickerInput';

const styles = theme => ({
  withoutLabel: {
    marginTop: theme.spacing.unit,
  },
});

class BaseInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      inputValue: props.value,
    };
  }
  formatValue = (value, isLocalizedNumber = false) => {
    const { schema } = this.props;
    const { format } = schema;
    const dateSupport = window.Modernizr && window.Modernizr.inputtypes.date;

    const val = value === undefined || value === null ? '' : value;
    switch (format) {
      case 'date':
        const date = dateSupport ? formatDate(val, 'YYYY-MM-DD') : formatDate(val, 'DD/MM/YYYY');
        return date;
      default:
        if (val !== '' && !isNaN(val)) {
          return val.toString().replace(/\./g, ',');
        } else if (isLocalizedNumber && val.slice(-1) !== ',') {
          return val.replace(/,/g, '.');
        }
        return val;
    }
  };
  throttledOnChange = debounce(value => {
    this.props.onChange(value);
  }, 500);
  onChange = event => {
    const { options } = this.props;
    const isLocalizedNumber = options.field && options.field === 'number';
    const formattedValue = this.formatValue(event.target.value, isLocalizedNumber);
    this.setState({ inputValue: formattedValue });
    this.throttledOnChange(formattedValue);
  };
  editableDateWithoutSupport = (format, readonly, formContext) => {
    const dateSupport = window.Modernizr && window.Modernizr.inputtypes.date;
    return format === 'date' && !dateSupport && (!readonly && formContext.formStatus === 'editable');
  };

  render = () => {
    const {
      classes,
      id,
      readonly,
      disabled,
      autofocus,
      onBlur,
      onFocus,
      options,
      schema,
      errorSchema,
      formContext,
      registry,
      label,
      onChange,
      ...inputProps
    } = this.props;
    const { inputValue } = this.state;
    inputProps.type = options.inputType || inputProps.type || 'text';
    const { format } = schema;
    const { validatorKey } = options;
    const hasError = !isEmpty(errorSchema);
    const formControlState = formContext.formControlStates[validatorKey];
    const shouldShowError = hasError && (formControlState.dirty || formContext.shouldStrictValidate);

    const displayLabel = schema.title !== undefined;
    const displayHint = options.hint !== undefined;

    return (
      <FormControl
        disabled={disabled || formContext.formStatus !== 'editable'}
        margin="normal"
        fullWidth
        error={shouldShowError}
        className={classnames({
          [classes.withoutLabel]: !displayLabel,
        })}
      >
        {displayLabel && (
          <InputLabel htmlFor={id} shrink>
            {label}
          </InputLabel>
        )}
        {this.editableDateWithoutSupport(format, readonly, formContext) ? (
          <DatePickerInput
            disabled={readonly || formContext.formStatus !== 'editable'}
            type="text"
            value={this.formatValue(inputValue)}
            onChange={() => {}}
            {...inputProps}
          />
        ) : (
          <Input
            id={id}
            {...inputProps}
            value={this.formatValue(inputValue)}
            readOnly={readonly || formContext.formStatus !== 'editable'}
            autoFocus={autofocus}
            onChange={this.onChange}
            type={format === 'date' ? format : null}
            onBlur={onBlur && (event => onBlur(inputProps.id, event.target.value))}
            onFocus={onFocus && (event => onFocus(inputProps.id, event.target.value))}
          />
        )}
        {displayHint && <FormHelperText>{options.hint}</FormHelperText>}
      </FormControl>
    );
  };
}

BaseInput.defaultProps = {
  type: 'text',
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false,
  options: [],
};

BaseInput.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.object,
  schema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  registry: PropTypes.object.isRequired,
};

export default withStyles(styles)(BaseInput);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/BaseInput.js